export default __webpack_public_path__ + "static/media/fruit-1920w.d49033ae.webp";